import { store } from "@store";
import { createNewSupportTicket } from "@services/api";
import NavigationService from "@utils/NavigationService";
import { Alert } from "react-native";
import analytics from "@services/analytics";
import { SUPPORT_FLOW } from "@constants/analyticsEventsCT";
import { ACCOUNT_SUSPENDED_DATA_VALUE_KEY } from "@constants/strings";
import { actions as authActions } from "@reducers/authReducer";
import { actions } from "@reducers/supportReducer";
import color from "@constants/color";
import t from "@constants/localization";

const PATH = "screens/SupportTree/utils";

const getSupportEventPayload = (value) => {
  switch (value) {
    case "APP_RELATED_HELP":
      return { type: "app related" };
    case "COMMISSION_RELATED_HELP":
      return { type: "commission related" };
    case "ORDER_RELATED_HELP":
      return { type: "order related" };
    case "PERSONAL_DETAILS_RELATED":
      return { type: "personal details related" };
    default:
      return { type: "other help" };
  }
};

const createSupportTicket = async () => {
  try {
    const { support } = store.getState();

    const { ticketPayload, topLevelKey } = support;
    const { data } = await createNewSupportTicket({ response: ticketPayload });

    // check if suspended request has been made, we want to mark has_raised_ticket: true in store
    // to fix navigation issue
    if (data && Array.isArray(ticketPayload)) {
      const hasCreatedSuspendedTicket = ticketPayload.some(
        (t) => t?.value === ACCOUNT_SUSPENDED_DATA_VALUE_KEY,
      );
      if (hasCreatedSuspendedTicket) {
        store.dispatch(
          authActions.getUserDetailsByTokenRequest({
            doNotShowSuspensionModal: true,
            showVacationModal: true,
          }),
        ); // updated overall everywhere
      }
    }

    const supportPayload = getSupportEventPayload(ticketPayload[0].value);
    analytics.trackEvent(SUPPORT_FLOW.SUPPORT_TICKET_CREATED, supportPayload);
    if (data.duplicate) {
      console.log("duplicate ticketi".repeat(10));
    }
    const { id } = data;
    // store.dispatch({ type: "SHOW_CREATE_TICKET", data: { show: true, id } });
    const message = data.duplicate
      ? t(`${PATH}/duplicateRegisterTicket`)
      : t(`${PATH}/yourNewProblemHasBeenRegistered`);
    store.dispatch(
      actions.showCreateTicketModal({
        show: true,
        id,
        message,
        buttonText1: t(`${PATH}/viewRegisteredIssue`),
        buttonText2: t(`${PATH}/okay`),
        endingMessage: t(`${PATH}/hai`),
      }),
    );
  } catch (e) {
    store.dispatch(
      actions.showCreateTicketModal({
        show: true,
        id: "",
        message: t(`${PATH}/pleaseTryAfterSometime`),
        buttonText1: "",
        buttonText2: t(`${PATH}/goToSupport`),
        endingMessage: "",
        buttonText2Color: color.lightBlack,
      }),
    );
    console.log(e);
  }
};

export default createSupportTicket;
